import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  selectBniTravelCurrentStepIndex, 
  selectBniTravelCurrentSubstepIndex, 
  selectBniTravelFlowType, 
  setBniTravelCurrentStepIndex, 
  setBniTravelCurrentSubstepIndex, 
  setBniTravelFlowType 
} from '../redux/features/bniTravelInsuranceFlowSlice';
import { bni_travel_insurance_flow } from '../pages/travelInsurancePages/newBniTravelPolicy/data';

const useBniTravelFlow = () => {
    const dispatch = useDispatch();
    const flowType = useSelector(selectBniTravelFlowType);
    const currentStepIndex = useSelector((state) => selectBniTravelCurrentStepIndex(state));
    const currentSubstepIndex = useSelector((state) => selectBniTravelCurrentSubstepIndex(state));

    const steps = bni_travel_insurance_flow[flowType] || bni_travel_insurance_flow.default || [];
    const currentStep = steps[currentStepIndex] || {};
    const currentSubstep = currentStep.substeps ? currentStep.substeps[currentSubstepIndex] : '';

    const handleFlowChange = (type, currentStepIndex, currentSubstepIndex) => {
        dispatch(setBniTravelFlowType({ type, currentStepIndex, currentSubstepIndex }));
    };

    const handleNextSubstep = () => {
        if (currentStep.substeps && currentSubstepIndex < currentStep.substeps.length - 1) {
            dispatch(setBniTravelCurrentSubstepIndex(currentSubstepIndex + 1));
        }
        else if (currentSubstepIndex === currentStep.substeps.length - 1) {
            handleNextStep();
        }
    };

    const handlePrevSubstep = () => {
        if (currentSubstepIndex > 0) {
            dispatch(setBniTravelCurrentSubstepIndex(currentSubstepIndex - 1));
        }
        else {
            handlePrevStep();
        }
    };

    const handleNextStep = () => {
        if (currentStepIndex < steps.length - 1) {
            dispatch(setBniTravelCurrentStepIndex(currentStepIndex + 1));
            dispatch(setBniTravelCurrentSubstepIndex(0));
        }
    };

    const handlePrevStep = () => {
        if (currentStepIndex > 0) {
            const prevStep = steps[currentStepIndex - 1] || {};
            const substepIndex = prevStep?.substeps?.length - 1 || 0;
            dispatch(setBniTravelCurrentStepIndex(currentStepIndex - 1));
            dispatch(setBniTravelCurrentSubstepIndex(substepIndex));
        }
    };

    return {
        handleFlowChange,
        handleNextSubstep,
        handlePrevSubstep,
        handleNextStep,
        handlePrevStep,
        flowType,
        steps,
        currentStep,
        currentStepIndex,
        currentSubstep,
        currentSubstepIndex,
    };
};

export default useBniTravelFlow;
